'use client';

import Image from 'next/image';

import Logo from '../../../../public/icons/logo.svg';

import { useNavigate } from '../../../../utils/navigate-to-products';
import { withCategories } from '@/api/categories';

import styles from './footer.module.css';
import { Skeleton } from 'antd';
import { useInfo } from '@/app/infoContext';


const Categories = withCategories(
  ({ categories }) =>
    categories.map((category) => {
      const { navigateToCategory } = useNavigate();

      return (
        <p
          key={category.categoryName}
          onClick={() => {
            navigateToCategory(category.id, category.categoryName);
          }}
          style={{ cursor: 'pointer' }}
        >
          {category.categoryName}
        </p>
      );
    }),
  { loadingComponent: <Skeleton active loading style={{ width: '100px' }} /> },
);

export const Footer = () => {
  const { navigateToTop, goToPage } = useNavigate();
  const { isMobile } = useInfo();
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Image
          priority
          src={Logo}
          alt={'logo'}
          onClick={navigateToTop}
          className={styles.logo}
          width={200}
          height={80}
        />
        <div className={`${styles.infoWrapper} ${isMobile ? styles.isMobile : ''}`}>
          {!isMobile && (
            <div className={styles.menuItems}>
              <Categories />
            </div>
          )}
          <div className={styles.legalInfo}>
            <p onClick={() => goToPage('/docs/user-agreement')}>Пользовательское соглашение</p>
            <p onClick={() => goToPage('/docs/public-offer')}> Публичная оферта</p>
            <p onClick={() => goToPage('/docs/contacts')}>Контакты</p>
            <p onClick={() => goToPage('/docs/payment-methods')}>Способы оплаты</p>
            <p onClick={() => goToPage('/docs/privacy-policy')}>Политика обработки персональных данных</p>
            <p onClick={() => goToPage('/docs/about-us')}>О нас</p>
          </div>
          <div className={styles.contactInfo}>
            <p>Контакты:</p>
            <p>+7 (3822) 333-100</p>
            <p style={{ marginTop: '12px' }}>Адрес:</p>
            <p>Московский тракт, 119, Томск, 634028</p>
          </div>
        </div>
        <div className={styles.footer}>
          <p>ИП ТАЧАТЯН АРСЕН ШАВАРШОВИЧ</p>
          <p>ИНН 701743133410</p>
          <p>ОГРНИП 318703100083401</p>
        </div>
      </div>
    </div>
  );
};
